module.exports = __webpack_public_path__ + "static/media/points-bene.4f465d03.svg";